import UAParser from 'ua-parser-js';

export default {
  filterDevice(kind, device) {
    // [Safari] newly plugged in media device id is empty and permission denied on camera won't work
    const isBrowserSafari = new UAParser().getBrowser().name.includes('Safari');
    return device.kind === kind && (isBrowserSafari || device.deviceId);
  }
}

